export default __webpack_public_path__ + "static/media/playstore-s2.aa86c042.webp";